module.exports = __webpack_public_path__ + "img/1723614580064-WhatsApp Image 2024-08-14 at 13.45.25.jpeg.9ea638f1.webp";